import { render } from "./Footer-GusMachadoYear.vue?vue&type=template&id=1ec22692&scoped=true"
const script = {}

import "./Footer-GusMachadoYear.vue?vue&type=style&index=0&id=1ec22692&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec22692"]])

export default __exports__